const HIDE_EPIC_FIELD_PREFIX = 'gh.epicShownOnRapidBoard.';
const HIDE_STATUS_FIELD_PREFIX = 'gh.statusShownOnRapidBoard.';
const HIDE_VERSION_FIELD_PREFIX = 'gh.versionShownOnRapidBoard.';

export const getHideEpics = (boardId: string | number): boolean =>
	localStorage.getItem(`${HIDE_EPIC_FIELD_PREFIX}${boardId}`) === 'false';

export const setHideEpics = (boardId: string | number, hideEpics: boolean) =>
	localStorage.setItem(`${HIDE_EPIC_FIELD_PREFIX}${boardId}`, (!hideEpics).toString());

export const getHideStatuses = (boardId: string | number): boolean =>
	localStorage.getItem(`${HIDE_STATUS_FIELD_PREFIX}${boardId}`) === 'false';

export const setHideStatuses = (boardId: string | number, hideStatuses: boolean) =>
	localStorage.setItem(`${HIDE_STATUS_FIELD_PREFIX}${boardId}`, (!hideStatuses).toString());

export const getHideVersions = (boardId: string | number): boolean =>
	localStorage.getItem(`${HIDE_VERSION_FIELD_PREFIX}${boardId}`) === 'false';

export const setHideVersions = (boardId: string | number, hideVersions: boolean) =>
	localStorage.setItem(`${HIDE_VERSION_FIELD_PREFIX}${boardId}`, (!hideVersions).toString());
